import factoryStore from '../components/factory-store'

const researchTopic = {
  ...factoryStore('ResearchTopic'),
}

const researchTopicStore = {
  ...researchTopic,
}

export default researchTopicStore
